export const TotalContactHeaders = {
    TotalCount: 'x-total-count',
    ActiveCount: 'x-total-active-count',
    BouncedCount: 'x-total-bounced-count',
    AbuseCount: 'x-total-abuse-count',
    InactiveCount: 'x-total-inactive-count',
    StaleCount: 'x-total-stale-count',
    UnsubscribedCount: 'x-total-unsubscribed-count',
    TransactionalCount: 'x-total-transactional-count',
    EngagedCount: 'x-total-engaged-count',
    NotconfirmedCount: 'x-total-notconfirmed-count',
};
